<template>
  <div>
    <TopNav />
    <router-view/>
    <Footer />
  </div>
</template>
<script>
import TopNav from '@/components/layouts/TopNav'
import Footer from '@/components/layouts/Footer'

export default {
  name: 'App',
  components: {
    TopNav,
    Footer
  }
}
</script>
